import { alpha, useTheme } from '@mui/material/styles';
import { Avatar, Box, Card, CardContent, Grid, ListItem, ListItemAvatar } from '@mui/material';
import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';

const mock = [
	{
		headerSlide: '',
		avatar: 'https://img.freepik.com/premium-photo/close-upa-confident-therapist-with-stethoscope_252847-50113.jpg?w=740',

		subSlideLine1: 'ABA Therapy is based on the study of learning and behavior.',
		subSlideLine2: '',
		subSlideLine3: '',
		subSlideLine4: '',

		headerBodySlide: 'Our program helps with:',

		bodySlideLine1: 'increase language, communication & social skills',
		bodySlideLine2:
			'build essential cognitive skills - attention, focus, memory, waiting, transitioning & emotional regulation',
		bodySlideLine3: 'address challenging behaviors and promote positive & safe behaviors',
		bodySlideLine4: 'develop independence such as self-care, toileting, grooming',
		bodySlideLine5: 'prepare for school with learn and play skills',

		LinkForBodyLine1: '',
		LinkForBodyLine2: '',
		LinkForBodyLine3: '',
		LinkForBodyLine4: '',
		LinkForBodyLine5: '',

		CTAType1: 'CTA',
		CTAText1: 'Schedule Therapy',
		CTALink1: '/contact'
	},

	{
		headerSlide: 'Why ABA?',
		avatar: 'https://images.squarespace-cdn.com/content/v1/55883ca2e4b0751e884a7f59/1575648362309-GMDSEHCTCIJNKFHUBISL/Poster+-+What+is+ABA%3F.png',

		subSlideLine1: '',
		subSlideLine2: '',
		subSlideLine3: '',
		subSlideLine4: '',

		bodySlideLine1: 'Practiced since 1960s and proven effective in clinical studies',
		bodySlideLine2: 'Recommended by American medical associations and the US Surgeon General.',
		bodySlideLine3: '',
		bodySlideLine4: '',
		bodySlideLine5: '',

		LinkForBodyLine1: '',
		LinkForBodyLine2: '',
		LinkForBodyLine3: '',
		LinkForBodyLine4: '',
		LinkForBodyLine5: '',

		CTAType1: 'INFO',
		CTAText1: 'Learn More',
		CTALink1: '/resources'
	}
];

const ABATherapyDescription = () => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				position: 'relative',
				boxShadow: 0,
				'&::after': {
					position: 'absolute',
					content: '""',
					width: '30%',
					zIndex: 1,
					top: 0,
					right: 0,
					height: '100%',
					backgroundSize: '18px 18px',
					backgroundImage: `radial-gradient(${alpha(theme.palette.primary.dark, 0.4)} 20%, transparent 20%)`,
					opacity: 0.2
				}
			}}>
			<Box
				position={'relative'}
				zIndex={2}
				/* paddingX={2} */
				marginX={{ xs: 'auto', sm: 'auto', md: '0px' }}
				display={'flex'}
				flexDirection={'column'}
				alignItems={'center'}>
				<Box maxWidth={{ xs: '74vw', sm: '90vw', md: '80vw', lg: '80vw' }} marginY={0} paddingY={0}>
					<Box
						marginX={'auto'}
						paddingX={'auto'}
						marginY={0}
						paddingY={0}
						sx={{
							height: { xs: 'auto', md: 1 },
							'& .slick-slide img': {
								objectFit: 'cover'
							},
							'& .slick-list, & .slick-slider, & .slick-track, & .slick-slide > div': {
								height: { xs: 'auto', md: 1 }
							},
							'& .slick-dots': {
								marginTop: { xs: 15, sm: 5, md: 7, lg: 4 },
								top: { xs: '84%', sm: '90%', md: '87%' },
								height: '25px'
							},
							'& .slick-prev': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '0%',
								marginLeft: 0,
								marginRight: '32px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							},
							'& .slick-next': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '100%',
								marginLeft: '62px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							}
						}}>
						<Box>
							{mock.map((item, i) => (
								<Box key={i}>
									<Card
										sx={{
											display: 'flex',
											flexDirection: {
												xs: 'column',
												md: (i + 1) % 2 === 0 ? 'row' : 'row-reverse'
											},
											boxShadow: 0,
											background: 'transparent'
										}}>
										<CardContent
											sx={{
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'left',
												marginLeft: { sx: 0, md: 2 }
											}}>
											<Box>
												<Box>
													<SimTypography variant={'h4'} sx={{ fontWeight: 700 }}>
														{item.headerSlide}
													</SimTypography>

													<SimTypography color='text.primary'>
														{item.subSlideLine1 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine1}</Box>
														)}
													</SimTypography>
												</Box>

												<Grid container spacing={'0'}>
													<Box paddingTop={2}>
														<SimTypography>
															{item.headerBodySlide === '' ? (
																<Box>
																	{' '}
																	<br />
																</Box>
															) : (
																<Box> {item.headerBodySlide} </Box>
															)}
														</SimTypography>
													</Box>

													{[
														{ line: item.bodySlideLine1, link: item.LinkForBodyLine1 },
														{ line: item.bodySlideLine2, link: item.LinkForBodyLine2 },
														{ line: item.bodySlideLine3, link: item.LinkForBodyLine3 },
														{ line: item.bodySlideLine4, link: item.LinkForBodyLine4 },
														{ line: item.bodySlideLine5, link: item.LinkForBodyLine5 }
													].map((item2, i2) => (
														<Grid item xs={12} key={i2}>
															<Box
																component={ListItem}
																disableGutters
																width={'auto'}
																padding={0}
																margin={0}
																display={'flex'}
																flexDirection={'row'}
																alignItems={'flex-start'}
																justifyItems={'left'}>
																{item2.line === '' ? null : (
																	<Box
																		display={'flex'}
																		flexDirection={'row'}
																		alignItems={'center'}
																		justifyItems={'center'}>
																		<Box
																			component={ListItemAvatar}
																			minWidth={'auto !important'}
																			marginRight={'0.5em'}
																			marginTop={'0.7em'}>
																			<Box
																				component={Avatar}
																				bgcolor={theme.palette.secondary.main}
																				width={20}
																				height={20}>
																				<svg
																					width={12}
																					height={12}
																					xmlns='http://www.w3.org/2000/svg'
																					viewBox='0 0 20 20'
																					fill='currentColor'>
																					<path
																						fillRule='evenodd'
																						d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
																						clipRule='evenodd'
																					/>
																				</svg>
																			</Box>
																		</Box>
																	</Box>
																)}
																<SimTypography padding={'8px'}>
																	{item2.line}
																</SimTypography>
															</Box>
														</Grid>
													))}
												</Grid>
											</Box>
											<Box display={'flex'} justifyContent={'flex-end'}>
												<SimButton
													variant='contained'
													backgroundColor={
														item.CTAType1 === 'CTA'
															? theme.palette.background.btnPrimaryCTA
															: theme.palette.background.btnSecondaryCTA
													}
													color={
														item.CTAType1 === 'CTA'
															? theme.palette.text.btnPrimaryCTA
															: theme.palette.text.btnSecondaryCTA
													}
													href={item.CTALink1}>
													{item.CTAText1}
												</SimButton>
											</Box>
										</CardContent>
									</Card>
								</Box>
							))}
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export { ABATherapyDescription };
